import React, {PropsWithChildren} from 'react';
import {Content} from "antd/es/layout/layout";
import {FloatButton, Layout} from "antd";
import {MenuOutlined} from "@ant-design/icons";
import {AuthStateContextProvider} from "../auth/LauncherAuthContext";
import {GoogleOAuthProvider} from '@react-oauth/google';
import {useNavigate} from "react-router";
import {SwitchLanguageIcon} from "../../commons/LanguageSwitchButton";
import {useLocaleContext} from "../../commons/translations/LocaleContext";
import {RpgLauncherHeader} from "./RpgLauncherHeader";
import {RpgLauncherFooter} from "./RpgLauncherFooter";
import {useMyMenu} from "../my/menu";

export const LauncherLayout: React.FC<PropsWithChildren & {disableNavigation?: boolean, disableBackground?: boolean}> = (props) => {
    const { disableNavigation, disableBackground } = props;
    const navigate = useNavigate();
    const { swapLocales } = useLocaleContext();
    const menuLinks = useMyMenu();

    return (
        <GoogleOAuthProvider clientId="148212513109-3njubdo65cruf3vu8iffkrgngr6pelsf.apps.googleusercontent.com">
            <AuthStateContextProvider>
                <Layout style={{height: '100vh'}}>
                    <RpgLauncherHeader disableNavigation={disableNavigation} />
                    <Content>
                        <div
                            style={{
                                padding: '5px',
                                minHeight: 'calc(100vh - 290px)',
                                backgroundImage: disableBackground ? 'none' : 'url(https://rpg-launcher-media.fra1.cdn.digitaloceanspaces.com/dice-dark-background.jpg)',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat'
                            }}>
                            {props.children}
                        </div>
                        {
                            !disableNavigation &&
                            <FloatButton.Group
                                shape={"square"}
                                trigger="click"
                                type="default"
                                style={{position: 'fixed', marginBottom: '70px', insetInlineEnd: 24}}
                                icon={<MenuOutlined />}
                            >
                                {menuLinks.map((ml) =>
                                    <FloatButton style={{padding: '5px'}} type={"primary"} onClick={() => navigate(ml.link)} icon={ml.icon} description={ml.text}/>)}
                            </FloatButton.Group>
                        }
                        <FloatButton style={{insetInlineEnd: 24}} onClick={swapLocales} icon={<SwitchLanguageIcon/>}/>
                        <RpgLauncherFooter disableNavigation={disableNavigation} />
                    </Content>
                </Layout>
            </AuthStateContextProvider>
        </GoogleOAuthProvider>
    )
}
